/* eslint-disable no-use-before-define */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-plusplus */
/* eslint-disable react/no-danger */
import React from 'react';
import { Container } from './styles';

interface PaginationPageProps {
  postsPerPage: number;
  totalPosts: number;
  paginate: (currentPage: number) => void;
  currentPage: number;
  // eslint-disable-next-line react/require-default-props
  firstAndLastPage?: boolean;
}

const Pagination = (props: PaginationPageProps) => {
  const { postsPerPage, totalPosts, paginate, currentPage, firstAndLastPage = false } = props;

  const pages = Math.ceil(totalPosts / postsPerPage);

  const MAX_ITEMS = 5;
  const MAX_LEFT = (MAX_ITEMS - 1) / 2;

  const maxFirst = Math.max(pages - (MAX_ITEMS - 1), 1);

  const first = Math.min(Math.max(currentPage - MAX_LEFT, 1), maxFirst);
  return (
    <Container>
      <nav>
        <ul className="pagination justify-content-end margin-pagination d-print-none m-0">
          {firstAndLastPage && (
            <li className="page-item">
              <button
                type="button"
                className="page-link"
                onClick={() => paginate(1)}
                aria-label="Primeiro"
                disabled={currentPage === 1}
              >
                <span aria-hidden="true">&laquo;</span>
                <span className="sr-only">Anterior</span>
              </button>
            </li>
          )}
          <li className="page-item">
            <button
              type="button"
              className="page-link"
              onClick={() => paginate(currentPage - 1)}
              aria-label="Anterior"
              disabled={currentPage === 1}
            >
              <span aria-hidden="true">&lsaquo;</span>
              <span className="sr-only">Anterior</span>
            </button>
          </li>
          {Array.from({ length: Math.min(MAX_ITEMS, pages) })
            ?.map((_, index) => index + first)
            ?.map((page) => (
              <li key={page} className="page-item">
                <button
                  type="button"
                  className={`${
                    page === currentPage ? 'pagination__item--active' : 'null'
                  } page-link `}
                  onClick={() => paginate(page)}
                >
                  {page}
                </button>
              </li>
            ))}
          <li className="page-item">
            <button
              type="button"
              className="page-link"
              onClick={() => paginate(currentPage + 1)}
              aria-label="Próximo"
              disabled={currentPage === pages}
            >
              <span aria-hidden="true">&rsaquo;</span>
              <span className="sr-only">Próximo</span>
            </button>
          </li>
          {firstAndLastPage && (
            <li className="page-item">
              <button
                type="button"
                className="page-link"
                onClick={() => paginate(pages)}
                aria-label="Último"
                disabled={currentPage === pages}
              >
                <span aria-hidden="true">&raquo;</span>
                <span className="sr-only">Anterior</span>
              </button>
            </li>
          )}
        </ul>
      </nav>
    </Container>
  );
};
export default Pagination;
